<template>
  <div style="height: 100%;overflow: auto;">
    <el-button type="primary" round style="margin-bottom: 20px;" @click="is_pop=true">立即购买</el-button>
    <div style="float: right">
      <el-button type="primary" round style="margin-bottom: 20px;" @click="is_img=true">图片库</el-button>
      <el-button type="primary" round style="margin-bottom: 20px;" @click="is_media=true">媒体库</el-button>
    </div>
    <el-table :data="list" border stripe>
      <el-table-column label="ID" prop="id" width="80px"></el-table-column>
      <el-table-column label="订单号" prop="order_no"></el-table-column>
      <el-table-column label="支付金额" prop="money"></el-table-column>
      <el-table-column label="容量" prop="size">
        <template v-slot="scope">
          {{scope.row.size}}M
        </template>
      </el-table-column>
      <el-table-column label="到期时间" prop="end_time"></el-table-column>
      <el-table-column label="创建时间" prop="addtime"></el-table-column>
      <el-table-column label="支付状态" prop="">
        <template v-slot="scope">
          <el-tag type="success" size="small" v-if="scope.row.is_pay==1">已支付</el-tag>
          <el-tag type="info" size="small" v-if="scope.row.is_pay==0">未支付</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="支付时间" prop="pay_time"></el-table-column>
      <el-table-column label="操作" width="120px">
        <template v-slot="scope">
          <!--          <el-button type="primary" @click="admin_edit(scope.row.id)" size="small" style="margin-right: 10px;">编辑</el-button>-->
<!--          <el-popconfirm title="确认操作？" @confirm="renew(scope.row.id)">-->
<!--            <el-button type="primary" size="small" slot="reference">续费</el-button>-->
<!--          </el-popconfirm>-->
          <el-popconfirm title="确认删除？" @confirm="del(scope.row.id)">
            <el-button type="danger" size="small" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 60px;"></div>
    <layer-page :total="total" :page-size="20"></layer-page>
    <Layer-pop title="立即购买" @close="vue_pop_show_hide" v-if="is_pop">
      <div style="display: flex;flex-wrap: wrap;">
        <template v-for="(val,key) in setting">
          <div :class="key==select ? 'select item' : 'item'" v-bind:key="val" @click="toselect(key)">
            <div class="money"><span style="font-size: 26px">￥</span>{{ val.money }}<span style="font-size: 28px"> /
            </span><span style="font-size: 20px">年</span></div>
            <div>{{ val.size }}M</div>
          </div>
        </template>
      </div>
      <div style="margin: 50px auto;text-align: center;">
        <el-button type="primary" round @click="topay">立即购买</el-button>
      </div>
      <div class="bg" v-if="is_pay">
        <div class="box">
          <div class="mt-10">扫码支付</div>
          <img :src="pay_code" style="width: 100%;height: 100%">
          <span class="iconfont icon-close-circle" @click="is_pay=false"></span>
        </div>
      </div>
    </Layer-pop>
    <layer-pop v-if="is_media" @close="is_media=false">
      <upload-list></upload-list>
    </layer-pop>
    <layer-pop v-if="is_img" @close="is_img=false">
      <upload-img></upload-img>
    </layer-pop>
  </div>
</template>

<script>
import LayerPop from "@/components/layer-pop.vue";
import LayerPage from "@/components/layer-page.vue";
import UploadList from "@/components/upload/upload-list.vue";
import UploadImg from "@/components/upload/upload-img.vue";
export default {
  name: "media",
  components: {UploadImg, UploadList, LayerPage, LayerPop},
  data(){
    return{
      list:[],
      page:1,
      total:0,
      is_pop:false,
      select:0,
      setting:[],
      pay_no:'',
      pay_code:'',
      is_pay:false,
      is_media:false,
      is_img:false,
    }
  },
  mounted() {
    try{
      this.get_list();
      this.get_setting();
    }catch (e){
      console.log(e);
    }
  },
  methods:{
    get_list: async function (){
        this.$_showLoading();
        let res = await this.$_api.company('media_order_list', {page: this.page,uid:this.user.uid});
        this.$_hideLoading();
        this.list = res.list;
        this.total = res.total;
    },
    get_setting:async function (){
      this.$_showLoading();
      let res =await this.$_api.setting('config',{type:'recharge'});
      this.$_hideLoading();
      if(res.errcode == 0) {
        this.setting = res.data.content.media
      }
    },
    toselect:function (key){
      this.select = key;
    },
    topay:async function (){
      let that = this;
      let data = this.setting[this.select];
      data['uid'] = this.user.uid;
      this.$_showLoading();
      let res = await this.$_api.company('media_buy', data);
      this.$_hideLoading();
      if(res.errcode == 0){
        console.log(res);
        this.is_pay = true;
        this.pay_no = res.pay_no;
        this.pay_code = res.url;
        clearInterval(this.timer);
        this.timer = setInterval(async function (){
          let check = await that.$_api.company('media_check_pay', {pay_no : res.pay_no});
          if (check.errcode == 0) {
            clearInterval(that.timer);
            that.$_showToast(check.errmsg);
            that.$router.replace('/company_recharge');

          }
        },2000)
      }else{
        this.$_showToast(res.errmsg,res.style);
      }
    },
    del:async function (id){
      let that = this;
      that.$_showLoading();
      let res = await that.$_api.company('media_del', {id:id});
      that.$_hideLoading();
      if (res.errcode == 0) {
        that.$_showToast(res.errmsg);
        that.get_list();
      }
    },
  }
}
</script>

<style scoped>
.item{
  width: calc(50% - 80px);
  margin: 40px;
  box-shadow: 0 0 5px #ccc;
  border-radius: 10px;
  padding: 40px 0;
  text-align: center;
  font-size: 28px;
}
.money{
  font-size: 40px;
  color: #ff0000;
  margin-bottom: 10px;
}
.select{
  box-shadow: 0 0 5px #ff0000;
}
.bg{
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0,0,0,0.3);
  align-items: center;
  justify-content: center;
  justify-items: center;
}
.bg .box{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  background: #fff;
  text-align: center;
}
.bg span{
  position: absolute;
  left: 50%;
  bottom: -100px;
  font-size: 40px;
  margin-left: -20px;
  color: #555;
  cursor: pointer;
}
</style>